<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <PaletteForm @submit-requested="submitRequested"></PaletteForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import PaletteForm from './PaletteForm.vue'

  export default {
  components: { PaletteForm },
  methods: {
    ...mapActions('palettes', ['postPalette']),
    submitRequested (input) {
      this.postPalette(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 